"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var react_2 = require("react");
var useMount = function (callback) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, react_2.useEffect)(callback, []);
};
exports.default = useMount;
